'use client'

import { Box, Text, VStack, useBreakpointValue } from '@chakra-ui/react'

export default function HalfSliceHero({
  headline,
  description,
}: {
  headline: string
  description: string
}) {
  const isMobile = useBreakpointValue({ base: true, md: false })

  return (
    <Box
      position="relative"
      h="600px"
      w="100%">
      <Box
        position="absolute" // 배경 효과를 위해 절대 위치 지정
        top={0}
        left={0}
        right={0}
        bottom={0}
        zIndex={-1} // 텍스트 위에 나타나지 않도록 설정
        backgroundImage={`
            linear-gradient(0deg, #ecf5f7 1px, transparent 0)
          `}
        backgroundSize="10px 10px" // 그리드 크기 설정
      />
      <Box
        position="absolute" // 배경 효과를 위해 절대 위치 지정
        top={0}
        left={0}
        right={0}
        bottom={0}
        zIndex={-1} // 텍스트 위에 나타나지 않도록 설정
        backgroundImage={`
           linear-gradient(90deg, #ecf5f7 1px, transparent 0)
         `}
        backgroundSize="10px 10px" // 그리드 크기 설정
      />
      <VStack
        w={'100%'}
        h="600px"
        justifyContent={'center'}
        alignItems={'center'}
        textAlign={'center'}
        zIndex={1}
        position="relative" // 텍스트가 배경 그리드 위에 있도록 설정
        px={4} // 여백 추가
      >
        <Text
          fontWeight={600}
          lineHeight="56px"
          fontSize={58}
          color="#000" // 텍스트 색상
        >
          {headline}
        </Text>
        <Text
          mt={12}
          fontSize={16}
          fontWeight={700}
          w={'260px'}
          lineHeight="20px"
          color="#000" // 텍스트 색상
        >
          {description}
        </Text>
      </VStack>
    </Box>
  )
}
